import React, { useRef } from 'react';
import { Modal, Button, Table } from 'react-bootstrap';

// 구간 할인 정보 파싱 함수 (필요시)
const parseTierDiscountInfo = (tierDiscountInfo) => {
    try {
        return JSON.parse(tierDiscountInfo)?.applied_tiers || [];
    } catch {
        return [];
    }
};

const BillingReceipt = ({ show, onHide, detail, yearMonth, isFinalAmount }) => {
    const printRef = useRef(null);

    // yearMonth 파싱
    const parts = yearMonth.split('_');
    const baseYearMonth = parts[0];
    const isFinal = parts.includes('final');
    const finalizedDateStr = isFinal && parts.length > 2 ? parts[2] : null;

    // 날짜 포맷
    const formattedMonth = `${baseYearMonth.slice(0, 4)}년 ${parseInt(baseYearMonth.slice(5, 7), 10)}월`;

    let lastDay;
    if (finalizedDateStr) {
        const finalizedDate = new Date(finalizedDateStr);
        finalizedDate.setDate(finalizedDate.getDate() - 1); // 하루 전
        lastDay = finalizedDate.getDate();
    } else {
        lastDay = yearMonth
            ? new Date(Number(baseYearMonth.slice(0, 4)), Number(baseYearMonth.slice(5, 7)), 0).getDate()
            : new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).getDate();
    }


    // 서버 정책 옵션
    let optionPrice = 0;
    let serverTotal = 0;
    if (detail.policyServerCnt && detail.option) {
        try {
            optionPrice = JSON.parse(detail.option)?.policy?.price || 0;
        } catch (e) { console.error(e); }
        serverTotal = detail.policyServerCnt * optionPrice;
    }
    const tiers = parseTierDiscountInfo(detail.tierDiscountInfo);
    const tierSum = tiers.reduce((sum, tier) => sum + (tier.monthly_fee_for_tier || 0), 0);
    const tierDiscountSum = tiers.reduce((sum, tier) => sum + (tier.tier_discount || 0), 0);

    // 인쇄 기능
    const handlePrint = () => {
        const printWindow = window.open('', '_blank');
        printWindow.document.write('<html><head><title>SafeDB 상세 영수증</title>');
        printWindow.document.write('<style>');
        printWindow.document.write(`
            body { font-family: Arial, sans-serif; padding: 20px; }
            .print-header { text-align: center; margin-bottom: 20px; }
            .print-header h2 { margin-bottom: 5px; }
            .print-section { margin-bottom: 25px; }
            .print-section h4 { margin-bottom: 10px; border-bottom: 1px solid #ddd; padding-bottom: 5px; }
            table { width: 100%; border-collapse: collapse; margin-bottom: 15px; }
            table, th, td { border: 1px solid #ddd; }
            th, td { padding: 8px; text-align: left; }
            th { background-color: #f2f2f2; }
            .text-right { text-align: right; }
            .text-success { color: green; }
            .text-bold { font-weight: bold; }
            .footer { margin-top: 30px; font-size: 12px; color: #666; text-align: center; }
            @media print {
                button { display: none; }
            }
        `);
        printWindow.document.write('</style></head><body>');

        // 헤더
        printWindow.document.write('<div class="print-header">');
        printWindow.document.write(`<h2>SafeDB 상세 영수증</h2>`);
        printWindow.document.write(`<p>${formattedMonth} 1일 ~ ${formattedMonth} ${lastDay}일</p>`);
        printWindow.document.write('</div>');

        // 정책 정보
        printWindow.document.write('<div class="print-section">');
        printWindow.document.write('<h4>요금 정책 정보</h4>');
        printWindow.document.write('<table>');
        printWindow.document.write('<tbody>');
        printWindow.document.write(`<tr><th width="30%">정책 이름</th><td>${detail.pricingPolicyName || '기본 정책'}</td></tr>`);
        printWindow.document.write(`<tr><th>적용 기간</th><td>${formattedMonth} 1일 ~ ${formattedMonth} ${lastDay}일</td></tr>`);
        printWindow.document.write('</tbody>');
        printWindow.document.write('</table>');
        printWindow.document.write('</div>');

        // 에이전트/정책 정보
        printWindow.document.write('<div class="print-section">');
        printWindow.document.write('<h4>에이전트/정책 정보</h4>');
        printWindow.document.write('<table>');
        printWindow.document.write('<tbody>');
        printWindow.document.write(`<tr><th>에이전트 평균/최대</th><td>${detail.avgAgentCount} / ${detail.maxAgentCount}</td></tr>`);
        printWindow.document.write(`<tr><th>Base Price/Agent</th><td>₩${detail.basePricePerAgent?.toLocaleString()}</td></tr>`);
        printWindow.document.write('</tbody>');
        printWindow.document.write('</table>');
        printWindow.document.write('</div>');

        // 구간별 요금 상세
        printWindow.document.write('<div class="print-section">');
        printWindow.document.write('<h4>구간별 요금 상세</h4>');
        printWindow.document.write('<table>');
        printWindow.document.write('<thead><tr><th>구간</th><th>에이전트수</th><th>단가</th><th>구간금액</th><th>할인율</th><th>구간할인</th></tr></thead>');
        printWindow.document.write('<tbody>');
        tiers.forEach(tier => {
            printWindow.document.write('<tr>');
            printWindow.document.write(`<td>${tier.tier_level} (${tier.agent_count_from}~${tier.agent_count_to})</td>`);
            printWindow.document.write(`<td>${tier.agents_in_tier}</td>`);
            printWindow.document.write(`<td>₩${tier.price_per_agent?.toLocaleString()}</td>`);
            printWindow.document.write(`<td>₩${tier.monthly_fee_for_tier?.toLocaleString()}</td>`);
            printWindow.document.write(`<td>${tier.discount_rate}${tier.discount_type === 'percent' ? '%' : ''}</td>`);
            printWindow.document.write(`<td class="text-success">-₩${tier.tier_discount?.toLocaleString()}</td>`);
            printWindow.document.write('</tr>');
        });
        printWindow.document.write('</tbody>');
        printWindow.document.write('<tfoot>');
        printWindow.document.write(`<tr><th colspan="5" class="text-right">구간 할인 총액</th><th class="text-success">-₩${Math.abs(tierDiscountSum).toLocaleString()}</th></tr>`);
        printWindow.document.write('</tfoot>');
        printWindow.document.write('</table>');
        printWindow.document.write('</div>');

        // 서버 정책
        if (serverTotal > 0) {
            printWindow.document.write('<div class="print-section">');
            printWindow.document.write('<h4>서버 정책</h4>');
            printWindow.document.write('<table>');
            printWindow.document.write('<tbody>');
            printWindow.document.write(`<tr><th>서버 정책</th><td>${detail.policyServerCnt}대 × ₩${optionPrice.toLocaleString()} = ₩${serverTotal.toLocaleString()}</td></tr>`);
            printWindow.document.write('</tbody>');
            printWindow.document.write('</table>');
            printWindow.document.write('</div>');
        }

        // 합계
        printWindow.document.write('<div class="print-section">');
        printWindow.document.write('<h4>합계</h4>');
        printWindow.document.write('<table>');
        printWindow.document.write('<tbody>');
        printWindow.document.write(`<tr><th>구간별 합계</th><td>₩${tierSum.toLocaleString()}</td></tr>`);
        if (serverTotal > 0) {
            printWindow.document.write(`<tr><th>서버 정책 합계</th><td>+ ₩${serverTotal.toLocaleString()}</td></tr>`);
        }
        printWindow.document.write(`<tr><th>총 금액</th><td>₩${detail.totalMonthlyFee?.toLocaleString()}</td></tr>`);
        printWindow.document.write(`<tr><th>최종금액(결제금액)</th><td class="text-bold">₩${detail.finalFee?.toLocaleString()}</td></tr>`);
        printWindow.document.write('</tbody>');
        printWindow.document.write('</table>');
        printWindow.document.write('</div>');

        // 푸터
        printWindow.document.write('<div class="footer">');
        printWindow.document.write('<p>SafeDB를 이용해주셔서 감사합니다.</p>');
        printWindow.document.write('</div>');

        printWindow.document.write('</body></html>');
        printWindow.document.close();
        setTimeout(() => {
            printWindow.print();
        }, 500);
    };

    return (
        <Modal show={show} onHide={onHide} centered size="lg">
            <Modal.Header closeButton>
                <Modal.Title>SafeDB 상세 영수증</Modal.Title>
            </Modal.Header>
            <Modal.Body ref={printRef}>
                <h5 className="mb-3">{formattedMonth} 상세 사용 내역</h5>

                {/* 정책 정보 */}
                <div className="mb-4">
                    <h6 className="border-bottom pb-2 mb-3">요금 정책 정보</h6>
                    <Table bordered hover>
                        <tbody>
                            <tr>
                                <th width="30%">정책 이름</th>
                                <td>{detail.pricingPolicyName || '기본 정책'}</td>
                            </tr>
                            <tr>
                                <th>적용 기간</th>
                                <td>{formattedMonth} 1일 ~ {formattedMonth} {lastDay}일</td>
                            </tr>
                        </tbody>
                    </Table>
                </div>

                {/* 에이전트/정책 정보 */}
                <div className="mb-4">
                    <h6 className="border-bottom pb-2 mb-3">에이전트/정책 정보</h6>
                    <Table bordered hover>
                        <tbody>
                            <tr>
                                <th>에이전트 평균/최대</th>
                                <td>{detail.avgAgentCount} / {detail.maxAgentCount}</td>
                            </tr>
                            <tr>
                                <th>Base Price/Agent</th>
                                <td>₩{detail.basePricePerAgent?.toLocaleString()}</td>
                            </tr>
                        </tbody>
                    </Table>
                </div>

                {/* 구간별 요금 상세 */}
                <div className="mb-4">
                    <h6 className="border-bottom pb-2 mb-3">구간별 요금 상세</h6>
                    <Table bordered hover>
                        <thead>
                            <tr>
                                <th>구간</th>
                                <th>에이전트수</th>
                                <th>단가</th>
                                <th>구간금액</th>
                                <th>할인율</th>
                                <th>구간할인</th>
                            </tr>
                        </thead>
                        <tbody>
                            {tiers.map((tier, idx) => (
                                <tr key={idx}>
                                    <td>{tier.tier_level} ({tier.agent_count_from}~{tier.agent_count_to})</td>
                                    <td>{parseFloat(tier.agents_in_tier).toFixed(4)}</td>
                                    <td>₩{tier.price_per_agent?.toLocaleString()}</td>
                                    <td>₩{tier.monthly_fee_for_tier?.toLocaleString()}</td>
                                    <td>
                                        {tier.discount_rate}
                                        {tier.discount_type === 'percent' ? '%' : ''}
                                    </td>
                                    <td className="text-success">-₩{tier.tier_discount?.toLocaleString()}</td>
                                </tr>
                            ))}
                        </tbody>
                        <tfoot>
                            <tr>
                                <th colSpan={5} className="text-end">구간 할인 총액</th>
                                <th className="text-success">
                                    -₩{Math.abs(tierDiscountSum).toLocaleString()}
                                </th>
                            </tr>
                        </tfoot>
                    </Table>
                </div>

                {/* 서버 정책 옵션 */}
                {serverTotal > 0 && (
                    <div className="mb-4">
                        <h6 className="border-bottom pb-2 mb-3">서버 정책</h6>
                        <Table bordered hover>
                            <tbody>
                                <tr>
                                    <th>서버 정책</th>
                                    <td>
                                        {detail.policyServerCnt}대 × ₩{optionPrice.toLocaleString()} = ₩{serverTotal.toLocaleString()}
                                    </td>
                                </tr>
                            </tbody>
                        </Table>
                    </div>
                )}

                {/* 합계 */}
                <div className="mb-2">
                    <h6 className="border-bottom pb-2 mb-3">합계</h6>
                    <Table bordered hover>
                        <tbody>
                            <tr>
                                <th>구간별 합계</th>
                                <td>₩{tierSum.toLocaleString()}</td>
                            </tr>
                            {serverTotal > 0 && (
                                <tr>
                                    <th>서버 정책 합계</th>
                                    <td>+ ₩{serverTotal.toLocaleString()}</td>
                                </tr>
                            )}
                            <tr>
                                <th>총 금액</th>
                                <td>₩{detail.totalMonthlyFee?.toLocaleString()}</td>
                            </tr>
                            <tr>
                                <th>최종금액(결제금액)</th>
                                <td className="fw-bold">₩{detail.finalFee?.toLocaleString()}</td>
                            </tr>
                        </tbody>
                    </Table>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="outline-secondary" onClick={onHide}>닫기</Button>
                <Button variant="primary" onClick={handlePrint}>인쇄하기</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default BillingReceipt;